var parent = require('../stable/global-this');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/actual/global-this.js
// module id = +m6n
// module chunks = 15